<li
    class="sidebar2-radio-dropdown"
    [ngClass]="{
        active: routerUrl.startsWith('/account/setup/integrations') || routerUrl.startsWith('/integrations'),
        open: toggleOpen,
    }">
    <header *ngIf="heading" class="sub-menu-v2--header" (click)="toggleOpen = !toggleOpen">
        <label>{{ heading }}</label>
        <i class="icon-ic-chevron-s1 icon-ic-chevron--expandable"></i>
    </header>

    <ul class="sub-menu-v2--dropdown">
        <li *ngFor="let item of options; let i = index">
            <input
                legacy-css
                type="radio"
                name="radio-subpanel"
                [value]="item.subRoute"
                class="sub-menu-v2-rb"
                [(ngModel)]="radioOption"
                [id]="heading + '-rb' + i"
                (change)="radioSelection(item)" />
            <label [for]="heading + '-rb' + i" [ngClass]="{ guide: item.guide }"
                >{{ item.label }}
                @if (item.subRoute !== 'add-ons') {
                    <span *ngIf="item.count" class="badge badge-stats pull-right">{{ item.count }}</span>
                    <span *ngIf="!item.count" class="badge badge-stats pull-right">{{
                        ($connections | async)?.data?.integrationProviders?.nodes?.length ?? 0 + preferredConnectionCount
                    }}</span>
                }
            </label>
        </li>
    </ul>
</li>
